export default "__VITE_ASSET__FbW82SOi__"